
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5LyIQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ef463eeaf943d737$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Czech
var $ef463eeaf943d737$export$2e2bcd8739ae039 = {
    'fabric.emoji.add.custom.emoji.label': "P\u0159idat sv\xe9 vlastn\xed emoji",
    'fabric.emoji.add.label': "P\u0159idat emoji",
    'fabric.emoji.cancel.label': "Zru\u0161it",
    'fabric.emoji.categories.label': "Vyberte kategorii smajl\xedk\u016F.",
    'fabric.emoji.categories.search.results': "V\xfdsledky vyhled\xe1v\xe1n\xed",
    'fabric.emoji.category.activity': "\u010Cinnosti",
    'fabric.emoji.category.all.uploads': "V\u0161echny nahran\xe9 polo\u017Eky",
    'fabric.emoji.category.flags': 'Vlajky',
    'fabric.emoji.category.foods': "J\xeddlo a pit\xed",
    'fabric.emoji.category.frequent': "\u010Cast\xe9",
    'fabric.emoji.category.nature': "P\u0159\xedroda",
    'fabric.emoji.category.objects': 'Objekty',
    'fabric.emoji.category.people': "Lid\xe9",
    'fabric.emoji.category.places': "Cestov\xe1n\xed a m\xedsta",
    'fabric.emoji.category.productivity': 'Produktivita',
    'fabric.emoji.category.symbols': 'Symboly',
    'fabric.emoji.category.user.uploads': "Va\u0161e nahran\xe9 polo\u017Eky",
    'fabric.emoji.choose.file.screenReaderDescription': "Vyberte soubor smajl\xedku. JPG, PNG nebo GIF. Maxim\xe1ln\xed velikost je 1\xa0MB.",
    'fabric.emoji.choose.file.title': 'Vybrat soubor',
    'fabric.emoji.delete.description': "Ve\u0161ker\xe9 existuj\xedc\xed v\xfdskyty tohoto emoji budou nahrazeny {emojiShortName}",
    'fabric.emoji.delete.label': 'Odstranit',
    'fabric.emoji.delete.screenreader.tooltip': "Chcete-li odstranit smajl\xedk {shortName}, stiskn\u011Bte kl\xe1vesu Backspace.",
    'fabric.emoji.delete.title': 'Odstranit emoji',
    'fabric.emoji.delete.tooltip': 'Odstranit',
    'fabric.emoji.emojipicker.emoi.roledescription': "tla\u010D\xedtko smajl\xedku",
    'fabric.emoji.emojipicker.error': 'Chyba',
    'fabric.emoji.error.delete.failed': "Odstran\u011Bn\xed se nezda\u0159ilo.",
    'fabric.emoji.error.image.too.big': "Vybran\xfd obr\xe1zek je v\u011Bt\u0161\xed ne\u017E 1 MB.",
    'fabric.emoji.error.invalid.image': "Vybran\xfd obr\xe1zek je neplatn\xfd.",
    'fabric.emoji.error.upload.failed': "Nahr\xe1v\xe1n\xed se nezda\u0159ilo",
    'fabric.emoji.error.upload.timeout': "Vypr\u0161el \u010Dasov\xfd limit nahr\xe1v\xe1n\xed",
    'fabric.emoji.image.requirements': 'JPG, PNG nebo GIF. Max. velikost je 1 MB.',
    'fabric.emoji.name.ariaLabel': "Zadejte n\xe1zev nov\xe9ho emotikonu",
    'fabric.emoji.picker': "V\xfdb\u011Br smajl\xedk\u016F",
    'fabric.emoji.pickerlist.grid': "{showSearchResults, select, true {V\xfdsledky vyhled\xe1v\xe1n\xed} other {Smajl\xedky}}",
    'fabric.emoji.pickerlist.tabpanel': "Panel seznamu a\xa0akc\xed smajl\xedk\u016F",
    'fabric.emoji.placeholder': "nap\u0159. ahoj",
    'fabric.emoji.preview': "Va\u0161e nov\xe9 emoji {emoji} vypad\xe1 skv\u011Ble!",
    'fabric.emoji.preview.title': "N\xe1hled",
    'fabric.emoji.retry.label': 'Zkusit znovu',
    'fabric.emoji.search.label': "N\xe1zev smajl\xedku",
    'fabric.emoji.search.placeholder': 'Vyhledat',
    'fabric.emoji.search.status': "Zobrazuj\xed se v\u0161echny smajl\xedky.",
    'fabric.emoji.select.skin.list.ariaLabel': "V\xfdb\u011Br odst\xednu pleti",
    'fabric.emoji.select.skin.tone.ariaLabel': "Vyberte odst\xedn pleti, vybr\xe1no: {selectedTone}"
};

});


//# sourceMappingURL=cs.18855928.js.map
